import { ChatAIIndicatorStatus } from '@/hooks/useChatAIStatus';

interface BadgeText {
    label: string;
    a11y: string;
}

/** Отображаемый текст бейджа в шапке ChatAIForm и в подписи под именем в миниатюре. */
export const STATUS_BADGE_TEXTS: Record<ChatAIIndicatorStatus, BadgeText> = {
    online: { label: 'AI · в сети', a11y: 'AI ассистент в сети' },
    degraded: { label: 'AI · с задержкой', a11y: 'AI ассистент работает с задержкой' },
    reconnecting: { label: 'AI · переподключение', a11y: 'Переподключение к AI ассистенту' },
    offline: { label: 'AI · недоступен', a11y: 'AI ассистент недоступен' },
    unknown: { label: 'AI · подключение', a11y: 'Подключение к AI ассистенту' },
};

/** Краткий текст рядом с аватаром в миниатюре (вместо «в сети»). */
export const STATUS_MINI_TEXTS: Record<ChatAIIndicatorStatus, string> = {
    online: 'в сети',
    degraded: 'с задержкой',
    reconnecting: 'переподключение',
    offline: 'недоступен',
    unknown: 'подключение',
};

export const STATUS_OFFLINE_HINT = 'Сервис недоступен. Попробуйте позже.';
export const STATUS_NOT_CONFIGURED_HINT = 'AI-ассистент не настроен на сервере.';
export const STATUS_RECONNECTING_HINT = 'Восстанавливаем связь с AI-ассистентом…';

export const getOfflineHint = (status: ChatAIIndicatorStatus, notConfigured: boolean): string | null => {
    if (notConfigured) return STATUS_NOT_CONFIGURED_HINT;
    if (status === 'offline') return STATUS_OFFLINE_HINT;
    if (status === 'reconnecting') return STATUS_RECONNECTING_HINT;
    return null;
};

// Один id на оба toast'а: mantine заменит yellow на green по тому же id,
// без второго всплытия рядом со старым.
const CHAT_AI_TOAST_ID = 'chat-ai-status';

export const TOAST_OFFLINE = {
    id: CHAT_AI_TOAST_ID,
    title: 'AI-ассистент недоступен',
    message: 'Не удалось получить статус сервиса. Попробуйте через минуту.',
};

export const TOAST_ONLINE = {
    id: CHAT_AI_TOAST_ID,
    title: 'AI-ассистент снова в сети',
    message: 'Соединение с сервисом восстановлено.',
};
